import * as React from 'react'
export const Cw = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#002b7f" d="M0 0h513v342H0z" />
    <path fill="#f9e814" d="M0 233.5h513v51H0z" />
    <path
      fill="#FFF"
      d="m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z"
    />
  </svg>
)
